import React, { useContext, useEffect, useState } from 'react'
import { formatDate, getSampleCsvHeadings, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router'

import { OtherContext } from '../../../context api/Others/OtherContext'
import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { useTasks } from '../../../hooks/Others/Audit/useTask'

export default function Task() {
  const { getAllTask, deleteManyTask, loading, paginate, updateTask } = useTasks()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { tasks } = useContext(OtherContext)
  //console.log('tasks : ', tasks)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterTask = tasks
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllTask({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_TASK')
  }, [])

  const handleChange = (event, value) => setPage(value)

  let tableBody = []

  if (!loading && filterTask.length > 0) {
    tableBody = filterTask.map((item) => {
      return [{ type: 'CHECKBOX', _id: item._id }, { value: item.taskMasterCode }, { value: item.name }, { value: item.taskType }, { value: item.description }]
    })
  }
  const sampleHeader = getSampleCsvHeadings(['taskType', 'name', 'description'])
  const layoutProps = {
    heading: 'Task Master',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    filename: 'tasks',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'AUDIT',
    sampleName: 'sample_task',
    sheetName: 'taskMaster',
    tempHeaders: sampleHeader,
    url: ROUTES.ADD_TASK,
    editUrl: `/edit-task/`,
  }

  return (
    <CustomTableLayout
      tableHeadings={['task Code', 'name', 'task type', 'description']}
      loading={loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      deleteMany={(val, setSelected) => deleteManyTask({ taskId: val }, setSelected)}
      checkbox
    />
  )
}
